import { render, staticRenderFns } from "./KD4.vue?vue&type=template&id=4623a841"
import script from "./KD4.vue?vue&type=script&lang=js"
export * from "./KD4.vue?vue&type=script&lang=js"
import style0 from "./KD4.vue?vue&type=style&index=0&id=4623a841&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports